import { useEffect, useState } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Dropdown } from '@zeeve-platform/dropdown-component';
import axios from 'axios';
import Footer from '../../../components/NextAndPrev';
import useUserStore from '../../../store/user';
import { getNetworkDetail as getNetworkDetailData, getNetworkList } from '../../../services/network';
import Urls from '../../../utils/baseUrls';
import { NetworkDataZoneTypes } from '../declaration';
import { makeid } from '../../../utils/helpers';

// Types of Props
interface Props {
    first: boolean;
    prev: () => void;
    nextPage: () => void;
    setNetworkDataZone: (obj: NetworkDataZoneTypes) => void;
    submit: () => void;
    last: boolean;
    networkDataZone: NetworkDataZoneTypes;
    networkId: string;
}

interface NetworkTypeInterfce {
    id: number | string;
    chainId: string | number;
    network: string;
    networkName: string;
    nodeTypes: string[];
    defaultConfig: {
        apis: string[];
        syncMode: string;
        gcMode: string;
        ipcRPC: boolean;
        txLookupLimit: number;
    };
}

const Network = ({ first, prev, nextPage, setNetworkDataZone, last, networkDataZone, submit, networkId }: Props) => {
    // States Define

    const [networkType, setNetworkType] = useState<string>('');
    const [updated, setUpdate] = useState<boolean>(false);
    const user = useUserStore((state) => state.details);

    // Variables Declarations
    const deploymentId: string = Urls.getDeploymentId();
    const getNewtworkDetails = async () => {
        try {
            const networkData: any = await getNetworkDetailData(networkId);
            // const networkData: any = await axios.get('http://localhost:3001/networks/asdasd');
            if (networkData && networkData.success) {
                const res = networkData.data;
                setNetworkType(res.network);
            } else {
                setNetworkType('');
            }
        } catch (error) {
            setNetworkType('');
        }
    };

    const getNewtworkList = async () => {
        const networkList: any = await getNetworkList(networkType, 'dedicated');
        // const networkList: any = await axios.get('http://localhost:3001/networks/defaults/asdas');
        if (networkList && networkList.success) {
            // setDefaults(networkList.data[0]);
            setNetworkDataZone({
                ...networkDataZone,
                network: networkList.data[0].network,
                networkName: networkList.data[0].networkName,
                nodeType: networkList.data[0].nodeTypes[0],
            });
        }
    };

    useEffect(() => {
        if (networkType !== '') getNewtworkList();
    }, [networkType]);

    useEffect(() => {
        // Api's call for network list and network details
        getNewtworkDetails();
    }, []);

    const unsetHighlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (b.classList.contains('formEmptyText')) {
                    b.classList.remove('formEmptyText');
                }
            } else {
                b.style.borderColor = '#ECEEF3';
            }
        }
    };
    const highlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (!b.classList.contains('formEmptyText')) {
                    b.classList.add('formEmptyText');
                }
            } else {
                b.style.borderColor = 'red';
            }
        }
    };

    const handleInput = (val: string, op: string) => {
        const usernamePattern = /[^a-zA-Z0-9]/g;
        let res;
        const etag = document.getElementById('err');
        switch (op) {
            case 'nodeName':
                if (val.length < 5) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the Node name should not be less than 5.';
                    }
                    highlight(`s3`, false);
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    unsetHighlight(`s3`, false);
                    const nObj = networkDataZone;
                    nObj.nodeName = val;
                    setNetworkDataZone(nObj);
                }
                setUpdate(!updated);
                break;
            case 'authUser':
                res = val.match(usernamePattern);
                if (res) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Invalid username format. Use only alphabet and digit.';
                    }
                    highlight(`s1`, false);
                } else if (val.length < 8) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the username should not be less than 8.';
                    }
                    highlight(`s1`, false);
                } else if (val.length > 20) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the username should not be more than 20.';
                    }
                    highlight(`s1`, false);
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    unsetHighlight(`s1`, false);
                    const nObj = networkDataZone;
                    networkDataZone.authUser = val;
                    setNetworkDataZone(nObj);
                }
                setUpdate(!updated);
                break;
            case 'authPassword':
                res = val.match(usernamePattern);
                if (res) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Invalid Password Format. Use only alphabet and digit.';
                    }
                    highlight(`s2`, false);
                } else if (val.length < 8) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the password should not be less than 8.';
                    }
                    highlight(`s2`, false);
                } else if (val.length > 20) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the password should not be more than 20.';
                    }
                    highlight(`s2`, false);
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    unsetHighlight(`s2`, false);
                    const nObj = networkDataZone;
                    networkDataZone.authPassword = val;
                    setNetworkDataZone(nObj);
                }
                setUpdate(!updated);
                break;
            default:
                break;
        }
    };

    const handleRpcAccessPoint = (op: string) => {
        const nObj = networkDataZone;
        if (op === 'http') {
            nObj.http = !nObj.http;
        }
        if (op === 'ws') {
            nObj.ws = !nObj.ws;
        }
        if (nObj.http === true || nObj.ws === true) {
            unsetHighlight(`s5`, true);
        } else {
            highlight(`s5`, true);
        }
        setUpdate(!updated);
        setNetworkDataZone(nObj);
    };


    const solve = () => {
        if (
            networkDataZone.nodeName !== '' &&
            'nodeName' in networkDataZone &&
            networkDataZone.authUser !== '' &&
            'authUser' in networkDataZone &&
            networkDataZone.authPassword !== '' &&
            'authPassword' in networkDataZone &&
            (networkDataZone.http !== false || networkDataZone.ws !== false) !== false
        ) {
            return nextPage();
        }

        if (networkDataZone.authUser === '' || networkDataZone.authUser === undefined) {
            return highlight(`s1`, false);
        }

        if (networkDataZone.authPassword === '' || networkDataZone.authPassword === undefined) {
            return highlight(`s2`, false);
        }

        if (networkDataZone.nodeName === '' || networkDataZone.nodeName === undefined) {
            return highlight(`s3`, false);
        }

        if (!networkDataZone.http && !networkDataZone.ws) {
            return highlight(`s5`, true);
        }
    };

    useEffect(() => {
        const http = networkDataZone.http ? true : false;
        const ws = networkDataZone.ws ? true : false;
        setNetworkDataZone({
            ...networkDataZone,
            http,
            ws,
        });
        setUpdate(!updated);
    }, []);

    return (
        <>
            <div className='col-11 mx-auto'>
                <div className='row'>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-4 col-11 form-floating cordaversion'>
                            <h6 className='mx-3 mt-4'>Network Type</h6>
                            <Dropdown
                                id='z14'
                                className='form-borderradius form-select mx-2 mt-3'
                                dropDownStyle={{ height: '50px' }}
                                defaultValue={networkDataZone.network}
                                options={[
                                    {
                                        value: networkDataZone.network,
                                        label: networkDataZone.networkName || networkDataZone.network,
                                    },
                                ]}
                                onChange={() => {
                                    unsetHighlight('z14', false);
                                }}
                                selectTitle={networkDataZone.networkName || networkDataZone.network}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-4 col-11 marginauto  form-floating cordaversion'>
                            <h6 className='mx-3 mt-3'>Deployment Type</h6>
                            <Dropdown
                                id='z17'
                                className='form-borderradius form-select mx-2 mt-3'
                                dropDownStyle={{ height: '50px' }}
                                defaultValue={networkDataZone.deploymentType}
                                options={[{ value: deploymentId, label: 'Native Shardeum Deployment' }]}
                                onChange={(e) => {
                                    unsetHighlight('z17', false);
                                    // setNext({ ...showNext, s7: true });
                                    setNetworkDataZone({
                                        ...networkDataZone,
                                        deploymentType: e.target.value,
                                    });
                                }}
                                selectTitle='Native Shardeum Deployment'
                                disabled
                            />
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='mt-4 col-8 ms-3' title='credentials required to access RPC server of Bor'>
                        <h6>
                            RPC Acces Credentials
                            <i className=' mx-1 fa fa-info-circle' />
                        </h6>
                    </div>
                </div>

                <div className='row  ms-1'>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <Inputbox
                                type='text'
                                className='form-control required'
                                defaultValue={networkDataZone.authUser}
                                autoComplete='off'
                                placeholder='username'
                                id={`s1`}
                                onChange={(e: { target: { value: string } }) => {
                                    handleInput(e.target.value, 'authUser');
                                }}
                            />
                            <label htmlFor='s1' className='form-pswd'>
                                Username
                            </label>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <Inputbox
                                type='text'
                                className='form-control required'
                                defaultValue={networkDataZone.authPassword}
                                autoComplete='off'
                                placeholder='password'
                                id={`s2`}
                                onChange={(e: { target: { value: string } }) => {
                                    handleInput(e.target.value, 'authPassword');
                                }}
                            />
                            <label htmlFor='s2' className='form-pswd'>
                                Password
                            </label>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <Inputbox
                                type='text'
                                className='form-control required'
                                defaultValue={networkDataZone.nodeName}
                                autoComplete='off'
                                placeholder='nodename'
                                id={`s3`}
                                onChange={(e: { target: { value: string } }) => {
                                    handleInput(e.target.value, 'nodeName');
                                }}
                            />
                            <label htmlFor='s3' className='form-pswd'>
                                Node Name
                            </label>
                        </div>
                    </div>
                </div>
                <div className='row  ms-1 mt-4'>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <h6 className='mx-3 mt-3' id='s5'>
                                Enable RPC Server
                            </h6>
                            <div className='row mt-1 mx-4'>
                                <div className='form-check col-xl-6 col-sm-12 my-2'>
                                    <Inputbox
                                        type='checkbox'
                                        className='form-check-input'
                                        id={`s5_http`}
                                        name={'http'}
                                        checked={networkDataZone.http}
                                        onChange={() => {
                                            handleRpcAccessPoint('http');
                                        }}
                                    />
                                    <label className='form-check-label mx-2' htmlFor={`s5_http`}>
                                        HTTP
                                    </label>
                                </div>
                                <div className='form-check col-xl-6 col-sm-12 my-2'>
                                    <Inputbox
                                        type='checkbox'
                                        className='form-check-input'
                                        id={`s5_ws`}
                                        name={'ws'}
                                        checked={networkDataZone.ws}
                                        onChange={() => {
                                            handleRpcAccessPoint('ws');
                                        }}
                                    />
                                    <label className='form-check-label mx-2' htmlFor={`s5_ws`}>
                                        WS
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <p id='err' className='text-center mt-4 mb-4' style={{ color: 'red', display: 'none' }}>
                    Error
                </p>
                <p id='err2' className='text-center mt-4 mb-4' style={{ color: 'red', display: 'none' }}>
                    Error
                </p>
            </div>
            <Footer
                isLastPage={last}
                submit={solve}
                isFirstPage={first}
                nextPage={solve}
                prevPage={prev}
                submitText='Create'
            />
        </>
    );
};
export default Network;
